import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Navbar from "./NavBar";
import NewWebsiteNotice from "./NewWebsiteNotice";
import Home from "./Home";
import StudentLogin from "./StudentLogin";


import { ProgressProvider } from "./ProgressContext";
import { LoadingProvider } from "./LoadingContext";
import LoadingOverlay from "./LoadingOverlay";
import { FeeProvider } from "./FeeContext";
import { API_BASE_URL } from "./config";


import TakeAdmission from "./TakeAdmission";
import SuccessStoriesNewsletter from "./SuccessStoriesNewsletter";
import GraduatesRoadmap from "./GraduatesRoadmap";
import WorkingProfessionals from "./WorkingProfessionals";
import GraduationStudents from "./GraduationStudents";
import AfterTenthTwelfth from "./AfterTenthTwelfth";
import Counselling from "./Counselling";
import ScrollToTop from "./ScrollToTop";
import GlobalTalent from "./GlobalTalent";
import IndustryExperience from "./IndustryExperience";
import StudyRoadmap from "./StudyRoadmap";



import FeesBenefits from "./FeesBenefits";
function App() {
  useEffect(() => {
    // ✅ Preload loader robot image early
    const robotLoaderImage = new Image();
    robotLoaderImage.src = "/assets/robot-loader.jpg";

    const fetchLocationData = async () => {
      try {
        const ipResponse = await fetch(
          "https://ipinfo.io/json?token=652654812dc5e9"
        );
        const ipData = await ipResponse.json();

        const visitData = {
          ip_address: ipData.ip,
          latitude: parseFloat(ipData.loc.split(",")[0]),
          longitude: parseFloat(ipData.loc.split(",")[1]),
          city: ipData.city,
          region: ipData.region,
          country: ipData.country,
          isp: ipData.org,
          timestamp: new Date().toISOString(),
        };

        await fetch(`${API_BASE_URL}/website-visit/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(visitData),
        });
      } catch (error) {
        console.error("Error fetching location data:", error);
      }
    };

    fetchLocationData();
  }, []);

  return (
    <LoadingProvider>
      <ProgressProvider>

        <img
          src="/assets/robot-loader.webp"
          alt=""
          aria-hidden="true"
          style={{
            position: "fixed",
            width: "1px",
            height: "1px",
            opacity: 0,
            pointerEvents: "none",
            left: "-9999px",
            top: "-9999px",
          }}
        />
        <FeeProvider>
          <NewWebsiteNotice />
          <LoadingOverlay />
          <ScrollToTop />

          <div className="uppar-nav">
            <div className="NavNames">
              <Navbar />
            </div>
          </div>

          <Routes>
            <Route path="/" element={<Home />} />

            <Route path="/success-stories-newsletter" element={<SuccessStoriesNewsletter />} />
            <Route path="/study-roadmap" element={<StudyRoadmap />} />
            <Route path="/fees-benefits" element={<FeesBenefits />} />
            <Route
              path="/global-talent"
              element={<GlobalTalent />}
            />

            <Route
              path="/industry-experience"
              element={<IndustryExperience />}
            />
            <Route path="/graduates" element={<GraduatesRoadmap />} />
            <Route path="/working-professionals" element={<WorkingProfessionals />} />
            <Route path="/college-students" element={<GraduationStudents />} />
            <Route path="/10th-12th" element={<AfterTenthTwelfth />} />
            <Route path="/student-login" element={<StudentLogin />} />
            <Route path="/admission" element={<TakeAdmission />} />
            <Route path="/counselling" element={<Counselling />} />




            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </FeeProvider>
      </ProgressProvider>
    </LoadingProvider>
  );
}

export default App;